import { Image } from 'antd';
import PropTypes from "prop-types";
import React from 'react';
import entete from '../../../../assets/img/entete.jpg';
import { LOGGED_USER } from '../../../../variables/constants';
import { frenchDate } from '../../../../variables/functions';
import { displayNumbers } from '../../../../variables/numbersFunctions';
import { DocumentFooter } from '../../../../components/docs/DocumentFooter';

const EmissionsNettesCedeesParExerciceEtCategorie = React.forwardRef((props, ref) => {
    const totalJanvier = props?.emissions?.reduce((sum, emission) => sum + emission.janvier, 0);
    const totalFevrier = props?.emissions?.reduce((sum, emission) => sum + emission.fevrier, 0);
    const totalMars = props?.emissions?.reduce((sum, emission) => sum + emission.mars, 0);
    const totalAvril = props?.emissions?.reduce((sum, emission) => sum + emission.avril, 0);
    const totalMai = props?.emissions?.reduce((sum, emission) => sum + emission.mai, 0);
    const totalJuin = props?.emissions?.reduce((sum, emission) => sum + emission.juin, 0);
    const totalJuillet = props?.emissions?.reduce((sum, emission) => sum + emission.juillet, 0);
    const totalAout = props?.emissions?.reduce((sum, emission) => sum + emission.aout, 0);
    const totalSeptembre = props?.emissions?.reduce((sum, emission) => sum + emission.septembre, 0);
    const totalOctobre = props?.emissions?.reduce((sum, emission) => sum + emission.octobre, 0);
    const totalNovembre = props?.emissions?.reduce((sum, emission) => sum + emission.novembre, 0);
    const totalDecembre = props?.emissions?.reduce((sum, emission) => sum + emission.decembre, 0);
    const total = props?.emissions?.reduce((sum, emission) => sum + emission.total, 0);
    return (
        <div ref={ref}>
            <Image
                src={entete}
                style={{
                    width: "100%",
                    height: "auto"
                }}
            />
            <div
                className=""
                style={{
                    padding: "10mm",
                    boxSizing: "border-box"
                }}
            >
                <div className='text-center'>
                    EMISSIONS NETTES CEDEES
                </div>
                <div className='text-center'>
                    EXERCICE {props.exercice}
                </div>
                <div className='text-center'>
                    CATEGORIE : {props.categorie}
                </div>
                <div className='text-center'>
                    Edité le {frenchDate(new Date().toISOString())} par {LOGGED_USER?.personne?.prenom} {LOGGED_USER?.personne?.nom}
                </div>
                <table
                    className="table table-bordered"
                    style={{ width: "100%" }}
                >
                    <thead>
                        <tr>
                            <th>Compagnie</th>
                            <th>Janvier</th>
                            <th>Février</th>
                            <th>Mars</th>
                            <th>Avril</th>
                            <th>Mai</th>
                            <th>Juin</th>
                            <th>Juillet</th>
                            <th>Août</th>
                            <th>Septembre</th>
                            <th>Octobre</th>
                            <th>Novembre</th>
                            <th>Décembre</th>
                            <th>TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.emissions.map((emission, index) => (
                            <tr key={index}>
                                <td>{emission.compagnie?.raisonSociale?.toUpperCase()}</td>
                                <td>{displayNumbers(emission.janvier)}</td>
                                <td>{displayNumbers(emission.fevrier)}</td>
                                <td>{displayNumbers(emission.mars)}</td>
                                <td>{displayNumbers(emission.avril)}</td>
                                <td>{displayNumbers(emission.mai)}</td>
                                <td>{displayNumbers(emission.juin)}</td>
                                <td>{displayNumbers(emission.juillet)}</td>
                                <td>{displayNumbers(emission.aout)}</td>
                                <td>{displayNumbers(emission.septembre)}</td>
                                <td>{displayNumbers(emission.octobre)}</td>
                                <td>{displayNumbers(emission.novembre)}</td>
                                <td>{displayNumbers(emission.decembre)}</td>
                                <td>{displayNumbers(emission.total)}</td>
                            </tr>
                        ))}
                        <tr>
                            <td>TOTAL</td>
                            <td>{displayNumbers(totalJanvier)}</td>
                            <td>{displayNumbers(totalFevrier)}</td>
                            <td>{displayNumbers(totalMars)}</td>
                            <td>{displayNumbers(totalAvril)}</td>
                            <td>{displayNumbers(totalMai)}</td>
                            <td>{displayNumbers(totalJuin)}</td>
                            <td>{displayNumbers(totalJuillet)}</td>
                            <td>{displayNumbers(totalAout)}</td>
                            <td>{displayNumbers(totalSeptembre)}</td>
                            <td>{displayNumbers(totalOctobre)}</td>
                            <td>{displayNumbers(totalNovembre)}</td>
                            <td>{displayNumbers(totalDecembre)}</td>
                            <td>{displayNumbers(total)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <DocumentFooter />
        </div>
    )
});
EmissionsNettesCedeesParExerciceEtCategorie.propTypes = {
    emissions: PropTypes.array,
    exercice: PropTypes.string,
    categorie: PropTypes.string
};
export default EmissionsNettesCedeesParExerciceEtCategorie